import en from './en/translation.json';
import ru from './ru/translation.json';

const resources = {
    en: { translation: en },
    ru: { translation: ru },
};

export { resources };
